import { getStore } from '../configureStore';
import { some } from 'lodash';
import config from 'config';
import { replace } from 'redux-little-router';
import Storage from 'services/Storage';
import { remotePaths, routeMap } from 'router/routes';

const resetPasswordUrl = '/profile/passwordRecovery';
const changePasswordUrl = '/profile/submitPassword';
const checkToken = '/profile/checkRestoreToken';
const adminConfig = '/settings';
const checkInnAndPwdUrl = '/checkInnAndPwdHashStatus';
const temporaryBannerUrl = '/banner/techWork';
const uuidUrl = '/certcode';
const externalServices = '/services';

function authInterceptor(req) {
  const token = Storage.getItem(config.tokenItemName);

  if (requiresBasicAuth(req.url) || (avalibleWithoutToken(req.url) && token === null)) {
    const basicAuthToken = window.btoa(`${config.clientId}:${config.clientSecret}`);

    req.headers = Object.assign({}, req.headers, {
      Authorization: `Basic ${basicAuthToken}`,
    });
  } else if (
    !~req.url.indexOf(routeMap.login_backend) &&
    !~req.url.indexOf(routeMap.armLoginBackend)
  ) {
    if (token === null) {
      if (config.isInspectorArm) {
        window.location = remotePaths.taxpayerSearching;
      }
      getStore().dispatch(replace(routeMap.login));
      return req;
    }

    req.headers = req.headers || {};
    req.headers = Object.assign({}, req.headers, {
      Authorization: `Bearer ${token}`,
    });
  }

  return req;
}

function requiresBasicAuth(url) {
  const routes = [
    routeMap.logout,
    routeMap.checkToken,
    routeMap.captcha,
    routeMap.armLogout,
    routeMap.armCheckToken,
    routeMap.armRunAs,
    resetPasswordUrl,
    changePasswordUrl,
    checkToken,
    checkInnAndPwdUrl,
    temporaryBannerUrl,
    uuidUrl,
    adminConfig,
  ];
  return some(routes, (v) => ~url.indexOf(v));
}

function avalibleWithoutToken(url) {
  const routes = [
    routeMap.externalAppointment,
    routeMap.appointmentGetManagement,
    routeMap.appointmentGetIFNS,
    routeMap.appointmentGetTorm,
    routeMap.appointmentGetServices,
    routeMap.appointmentGetSlots,
    routeMap.appointmentBook,
    routeMap.appointmentCancelBooking,
    externalServices,
  ];
  return some(routes, (v) => ~url.indexOf(v));
}
export default authInterceptor;
